<template>
  <div
    v-if="showTooltip"
    data-png-ignore
    class="dppl-info-tooltip"
    :class="{
      'full-width-activator': fullWidthActivator,
      [tooltipKey]: Boolean(tooltipKey),
    }"
  >
    <DpplTooltip
      :tooltip-placement="tooltipPlacement"
      :tooltip-offset="tooltipOffset"
      :multiple-tooltip-offsets="multipleTooltipOffsets"
      :max-width="maxWidth"
      :teleport="teleport"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <v-icon
          :color="iconColor"
          size="18px"
          :icon="icon"
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        />
      </template>
      <template #tooltip-content>
        <div class="tooltip-content">
          <strong v-if="tooltip.title">{{ tooltip.title }}<br></strong>
          <div class="tooltip-html" @click.stop>
            <DpplSafeHtml :html="html" />
          </div>
        </div>
      </template>
    </DpplTooltip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';

const props = defineProps({
  tooltip: {
    type: Object,
    default: () => ({}),
  },
  icon: {
    type: String,
    default: '$information-outline',
  },
  iconColor: {
    type: String,
    default: 'iconDefault',
  },
  fullWidthActivator: {
    type: Boolean,
    default: false,
  },
  tooltipPlacement: {
    type: String,
    default: 'right',
  },
  maxWidth: {
    type: String,
    default: '252px',
  },
  tooltipOffset: {
    type: Number,
    default: 12,
  },
  multipleTooltipOffsets: {
    type: Object,
    default: () => ({}),
  },
  teleport: {
    type: Boolean,
    default: false,
  },
});

const rawHtml = computed(() => props.tooltip?.html || props.tooltip?.body_r || '');

const html = computed(() => {
  if (!rawHtml.value) return '';
  return rawHtml.value.trim();
});

const showTooltip = computed(() => Boolean(rawHtml.value));

const tooltipKey = computed(() => props.tooltip?.key || '');
</script>

<style lang="less" scoped>
.dppl-info-tooltip {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &.full-width-activator {
    width: 100%;
  }
}

:deep(.activator) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.tooltip) {
  width: v-bind(maxWidth);
}

.tooltip-content {
  white-space: pre-line;
}

.tooltip-html {
  font-size: 13px;
  font-weight: 500;

  :deep(p),
  :deep(span),
  :deep(div),
  :deep(li),
  :deep(strong) {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    color: @text-dark;
  }

  :deep(p) {
    margin: 0;
  }

  :deep(ul),
  :deep(ol) {
    margin-left: 8px;
  }

  :deep(strong) {
    font-weight: 400;
    color: @text-darkest;
  }

  :deep(a) {
    font-size: 13px;
    font-weight: 500;
    color: @text-brand;
  }
}
</style>
